module.exports = __webpack_public_path__ + "static/formulas1-b14eed14c6c9dcdabcc89493caa1fd25.jpg";